import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../api';
import Layout from '../components/Layout';
import { T } from '../styles/theme';
import { useIsMobile } from '../hooks/useIsMobile';

function ProLock() {
  return (
    <div className="flex flex-col items-center justify-center py-20 px-4">
      <div className="w-20 h-20 rounded-full flex items-center justify-center mb-6" style={{ backgroundColor: T.border }}>
        <svg className="w-10 h-10" fill="none" stroke={T.violet} strokeWidth={1.5} viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" d="M16.5 10.5V6.75a4.5 4.5 0 10-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 002.25-2.25v-6.75a2.25 2.25 0 00-2.25-2.25H6.75a2.25 2.25 0 00-2.25 2.25v6.75a2.25 2.25 0 002.25 2.25z" />
        </svg>
      </div>
      <h2 className="section-title mb-2">Contenuto riservato ai Pro</h2>
      <p className="text-sm mb-6 text-center max-w-md" style={{ color: T.muted, fontFamily: T.fontBody }}>Questa sezione è riservata agli abbonati Pro. Passa a Pro per scoprire i migliori prodotti da rivendere.</p>
      <Link to="/profilo" className="px-6 py-3 rounded-xl font-bold text-sm transition-opacity hover:opacity-90" style={{ background: 'linear-gradient(135deg, #d97706, #f59e0b)', color: 'white' }}>
        Passa a Pro
      </Link>
    </div>
  );
}

function MarginBadge({ margine, isMobile }) {
  let badgeClass;
  if (margine >= 30) { badgeClass = 'badge badge-green'; }
  else if (margine >= 15) { badgeClass = 'badge badge-amber'; }
  else { badgeClass = 'badge badge-red'; }
  return (
    <span className={`${badgeClass} text-xs font-bold rounded-full`} style={{ fontSize: isMobile ? '0.7rem' : '0.82rem', padding: isMobile ? '3px 8px' : '4px 12px' }}>
      +{margine}%
    </span>
  );
}

export default function BestProductPage() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [locked, setLocked] = useState(false);
  const [corsoLocked, setCorsoLocked] = useState(false);
  const isMobile = useIsMobile();

  useEffect(() => {
    api.get('/corso/check-modulo1').then((r) => {
      if (!r.data.modulo1_completo) { setCorsoLocked(true); setLoading(false); return; }
      api.get('/best-products').then((r2) => setProducts(Array.isArray(r2.data) ? r2.data : [])).catch((e) => {
        if (e.response?.status === 403) setLocked(true);
      }).finally(() => setLoading(false));
    }).catch(() => {
      api.get('/best-products').then((r) => setProducts(Array.isArray(r.data) ? r.data : [])).catch((e) => {
        if (e.response?.status === 403) setLocked(true);
      }).finally(() => setLoading(false));
    });
  }, []);

  return (
    <Layout>
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" style={{ fontFamily: T.fontBody }}>
        <div className="mb-6">
          <h1 className="page-title">Best Product</h1>
          <p className="text-sm mt-1" style={{ color: T.muted }}>I migliori prodotti della settimana da rivendere</p>
        </div>

        {loading ? (
          <div className="text-center py-16" style={{ color: T.muted }}>Caricamento...</div>
        ) : corsoLocked ? (
          <div className="card rounded-2xl">
            <div className="flex flex-col items-center justify-center py-20 px-4">
              <div className="w-20 h-20 rounded-full flex items-center justify-center mb-6" style={{ backgroundColor: T.border }}>
                <span className="text-4xl">🎓</span>
              </div>
              <h2 className="section-title mb-2">Prima completa il Modulo 1</h2>
              <p className="text-sm mb-6 text-center max-w-md" style={{ color: T.muted }}>Completa il Modulo 1 del corso per sbloccare i Best Product.</p>
              <Link to="/corso" className="btn-primary px-6 py-3 rounded-xl font-bold text-sm">Vai al Corso</Link>
            </div>
          </div>
        ) : locked ? (
          <div className="card rounded-2xl"><ProLock /></div>
        ) : products.length === 0 ? (
          <div className="card text-center py-16 rounded-2xl">
            <p className="text-lg" style={{ color: T.muted }}>Nessun prodotto disponibile</p>
          </div>
        ) : (
          <div style={{ display: 'grid', gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(3, 1fr)', gap: isMobile ? 8 : 16 }}>
            {products.map((b) => (
              <div key={b.id} className="card rounded-2xl overflow-hidden flex flex-col transition-all hover:scale-[1.01]">
                {b.foto_url && (
                  <div className="overflow-hidden" style={{ borderBottom: `1px solid ${T.border}`, height: isMobile ? 140 : 260 }}>
                    <img src={b.foto_url} alt={b.titolo} className="w-full h-full object-cover" />
                  </div>
                )}
                <div className="flex flex-col flex-1" style={{ padding: isMobile ? 12 : 20 }}>
                  <div className="flex items-center justify-between mb-2">
                    <h3 className="font-bold" style={{ color: T.text, fontSize: isMobile ? '0.85rem' : '1.1rem', lineHeight: 1.2 }}>{b.titolo}</h3>
                    {b.margine_percentuale > 0 && <MarginBadge margine={b.margine_percentuale} isMobile={isMobile} />}
                  </div>
                  <p className="flex-1 mb-3 leading-relaxed" style={{ color: T.muted, fontSize: isMobile ? '0.72rem' : '0.875rem' }}>{b.descrizione}</p>
                  {b.fornitore_nome && (
                    <div className="mb-3 flex items-center gap-2 flex-wrap">
                      <div style={{ display: 'inline-flex', alignItems: 'center', gap: 6, padding: '4px 10px', borderRadius: 8, background: 'rgba(167,139,250,0.08)', border: `1px solid ${T.border}` }}>
                        <span style={{ fontSize: isMobile ? '0.65rem' : '0.75rem', color: T.muted }}>Fornitore:</span>
                        <span style={{ fontSize: isMobile ? '0.7rem' : '0.8rem', color: T.violet, fontWeight: 600 }}>{b.fornitore_nome}</span>
                      </div>
                      {b.fornitore_whatsapp && (
                        <a href={b.fornitore_whatsapp} target="_blank" rel="noopener noreferrer"
                          style={{ display: 'inline-flex', alignItems: 'center', gap: 5, padding: '5px 12px', borderRadius: 8, background: '#16a34a', color: '#fff', fontSize: isMobile ? '0.65rem' : '0.75rem', fontWeight: 700, textDecoration: 'none', transition: 'opacity 0.15s' }}
                          onMouseEnter={(e) => e.currentTarget.style.opacity = '0.85'}
                          onMouseLeave={(e) => e.currentTarget.style.opacity = '1'}>
                          <span>💬</span> Contatta su WhatsApp
                        </a>
                      )}
                    </div>
                  )}
                  <div className="mb-4">
                    <p className="font-semibold uppercase tracking-wider" style={{ color: T.muted, fontSize: isMobile ? '0.6rem' : '10px' }}>Valore di Resell</p>
                    <p className="font-bold" style={{ color: T.green, fontSize: isMobile ? '1.1rem' : '1.3rem' }}>€{b.prezzo_vendita}</p>
                  </div>
                  {b.link && (
                    <a href={b.link} target="_blank" rel="noopener noreferrer"
                      className="btn-primary inline-flex items-center justify-center gap-2 px-4 py-2.5 rounded-xl text-sm font-bold">
                      Vedi prodotto
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25" />
                      </svg>
                    </a>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </main>    </Layout>
  );
}
